export enum FileName {
  SkillMd = "SKILL.md",
  AgentsMd = "AGENTS.md",
  ClaudeMd = "CLAUDE.md",
  OpenclawJson = "openclaw.json",
}

export enum ImportPrefix {
  Openclaw = ".openclaw/",
}
